<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="-10 0 310 300">
    <path
      fill="currentColor"
      d="M56 37l-18 19v188l18 18h75l19 -18v-188l-19 -19h-75zM56 244v-188h75v188h-75zM188 56l18 -19h57l18 19v56l-18 19h-57l-18 -19v-56zM206 56v56h57v-56h-57zM188 187l18 -18h57l18 18v57l-18 18h-57l-18 -18v-57zM206 187v57h57v-57h-57z"
    />
  </svg>
</template>
